var Filter = Backbone.Model.extend({
    defaults: {
        filters: {}
    },
    initialize: function(){
        _.bindAll( this, 'registerFilters' );
    },
    registerFilters: function( props ) {
        var filters = this.get( 'filters' );

        var t = Object.keys( props );
        for ( var i = 0; i < t.length; i++ ) {
            var key = t[i];
            var value = props[key];

            if ( typeof filters[key] === 'undefined' ) {
                filters[key] = [];
            }
            if ( ! filters[key].includes( value ) ) {
                filters[key].push( value );
            }
        }
        this.set({'filters': filters});
        // alert( "registerFilters ran" );
        this.trigger( 'updateFilters' );
    }
});

export {Filter};